module.exports = __webpack_public_path__ + "static/media/template-default.42326396.jpg";